import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link, useHistory, useParams } from 'react-router-dom';
import BusinessDetailsApi from '../../../../Api/BusinessDetailsApi';
import SupplierProductApi from '../../../../Api/SupplierProductApi';
import { getResponseError, getUserDetailsCookie } from '../../../../Api/Utils/apiUtils';
import { createChatRoom } from '../../../../Api/Utils/chatUtils';
import SupplierExtendedDetails from '../../../../Components/Accounts/Supplier/SupplierExtendedDetails/SupplierExtendedDetails';
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert';
import Section from '../../../../Components/Section/Section';
import './../../../../Components/Accounts/Supplier/SupplierExtendedDetails/singleSupplier.css'
import ScaleLoader from "react-spinners/ScaleLoader";

const SingleSupplierComponent = () => {
    const history = useHistory()
    const { supplierID } = useParams()
    const [errorMesage, seterrorMesage] = useState(null);
    const [businessDetails, setbusinessDetails] = useState(null);
    const [products, setproducts] = useState(null);
    const [isloading, setisloading] = useState(true)

    const removeError = () => {
        setTimeout(() => {
            seterrorMesage(null)
        }, 5000);
    }

    useEffect(() => {
        const loadSingleBusinessDetails = async () => {
            const businessResponse = await BusinessDetailsApi.getBusinessDetails(parseInt(supplierID))
            const businessResponseApiError = getResponseError(businessResponse)
            if (businessResponseApiError) {
                seterrorMesage(businessResponseApiError)
                removeError()
            }else{
                const businessData = businessResponse.objectVal
                setbusinessDetails(businessData)
                const businessID = businessData.id
                const productResponse = await SupplierProductApi.getProductDetails(businessID)
                const productsResponseApiError = getResponseError(productResponse)
                if (productsResponseApiError) {
                    seterrorMesage(productsResponseApiError)
                    removeError()
                    setisloading(false)
                }else{
                    const productsData = productResponse.objectVal
                    setproducts(productsData)
                    setisloading(false)
                }
            }
        }
        loadSingleBusinessDetails()
    }, [supplierID]);

    // create chatroom
    const messageWithTheCustomer = (businessdata) => {
        const userdata = getUserDetailsCookie()
        const setupMessage = {
            mBuyerImage: `${userdata.imageUrl}`,
            mBuyerName: `${userdata.firstName} ${userdata.lastName}`,
            mSupplierImage: businessdata.businessLogo && businessdata.businessLogo.imageUrl,
            mSupplierName: `${businessdata.businessName}`,
            mSupplierPlayerId: "",
            mBuyerPlayerId: ""
        }
        createChatRoom(userdata.id, businessdata.userId, setupMessage)
        const loc = {
            pathname: '/messages',
            state: { id: `` }
        }
        history.push(loc)
        history.replace(loc)
    }

    return (
        <>
        {isloading ? 
        <div className="loading-section">
            <ScaleLoader color={'#591EC1'} loading={isloading} size={40} />
        </div>
        :
        <Section contStyle={{minHeight: "50vh", backgroundColor: "#fff", marginBottom: "80px"}}>
            <Container>
                {businessDetails &&
                <div className='single-supplier-container'>
                    <ErrorAlert>{errorMesage}</ErrorAlert>
                    <SupplierExtendedDetails business={businessDetails} messageSupplier={messageWithTheCustomer} prod={products} />
                    <div className="back-button">
                        <Link to={`/suppliers`}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </Link>
                    </div>
                </div>}
            </Container>
        </Section>}
        </>
    ) 
};

export default SingleSupplierComponent;
